import React from 'react'
import { ViewStyle, ScrollView, View, TextStyle, TouchableOpacity, Platform } from 'react-native'
import { Text } from '../text'
import { color } from '../../theme'
import { observer } from 'mobx-react-lite'
interface TabControllerProps {
  tabs: any[]
  setActiveTab: any
  activeTab: number
  containerStyle?: ViewStyle
  matchID?: boolean
}

export const TabController = observer((props: TabControllerProps) => {
  const { matchID, tabs, activeTab, setActiveTab, containerStyle } = props

  const TAB_STYLE: any = { ...TABS, overflowX: 'auto', alignItems: 'baseline' }

  return (
    <>
      <View style={TAB_STYLE}>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={{ ...CONTAINER, ...containerStyle }}
        >
          {tabs
            .filter((f) => f.enable === undefined || f.enable)
            .map((tab: any, index: number) => {
              let active = false
              if (matchID) {
                active = tab.id === activeTab
              } else {
                active = index === activeTab
              }
              return (
                <TouchableOpacity
                  // @ts-ignore
                  dataSet={{ qat: `${tab.label.toLowerCase()}-tab` }}
                  key={tab.label}
                  onPress={() => {
                    setActiveTab(matchID ? tab.id : index)
                    tab.onPress()
                  }}
                  style={{
                    marginRight: 10,
                    backgroundColor: active ? '#1B59F820' : color.shade04,
                    ...TAB_BTN,
                    ...tab.customStyle,
                  }}
                >
                  <View
                    style={{
                      flex: 1,
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Text
                      style={active ? ACTIVE : NORMAL}
                      tx={tab.label}
                      variant="body1Emphasized"
                    />
                    {tab?.numeral && (
                      <Text
                        tx={tab?.numeral.toString()}
                        variant="body1Emphasized"
                        style={{
                          paddingLeft: 5,
                          color: active ? color.blue : color.shade50,
                        }}
                      />
                    )}
                  </View>
                </TouchableOpacity>
              )
            })}
        </ScrollView>
      </View>
      {tabs[activeTab]?.component ? tabs[activeTab]?.component : null}
    </>
  )
})

const TABS: ViewStyle = { flexDirection: 'column' }
const CONTAINER: ViewStyle = {
  flexDirection: 'row',
  marginBottom: 10,
  paddingLeft: Platform.OS === 'web' ? 0 : 20,
  justifyContent: 'space-around',
  // @ts-ignore
  overflowX: 'auto',
}
const ACTIVE: TextStyle = {
  alignSelf: 'center',
  textAlign: 'center',
  color: color.blue,
}
const NORMAL: TextStyle = { alignSelf: 'center', textAlign: 'center', color: color.black }
const TAB_BTN: ViewStyle = { height: 40, borderRadius: 100, paddingLeft: 20, paddingRight: 20 }
